import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHouseDamage } from '@fortawesome/free-solid-svg-icons'
import whiteLogo from '../../assets/menu/logolobobranco.png'
import './style.css'

function Menu() {

    return (
        <nav class="sidenav">
            <div>
                <li><a href="#home" className='logo'><img src={whiteLogo}></img></a></li>
            </div>
            <div className='menu'>
                <li><a href="#home"><FontAwesomeIcon icon={faHouseDamage} /></a></li>
                <li><a href="#about"><i class="fa fa-user-circle-o" aria-hidden="true"></i></a></li>
                <li><a href="#portifolio"><i class="fa fa-code" aria-hidden="true"></i></a></li>
                <li><a href="#contact"><i class="fa fa-envelope-o" aria-hidden="true"></i></a></li>
            </div>
            <div className='networks'>
                <li><a href="#"><i class="fa fa-github-alt" aria-hidden="true"></i></a></li>
                <li id='linkedin'><a href="#"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
            </div>
        </nav>
    );
}

export default Menu;